import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WorksCategory from "../pages/works/page";
import NewsCategory from "../pages/news/page";
import WorkDetail from "../pages/work-detail/page";
import NewsDetail from "../pages/news-detail/page";
import Profile from "../pages/profile/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/works",
    element: <WorksCategory />,
  },
  {
    path: "/category/news",
    element: <NewsCategory />,
  },
  {
    path: "/detail/work/:id",
    element: <WorkDetail />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;